import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'regulation'

const RegulationModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default RegulationModule



// WEBPACK FOOTER //
// ./src/store/module/regulation/index.js